import { setSentryInstance } from "../Sentry/Sentry.utils";
import {
  SENTRY_DSN,
  SENTRY_ENVIRONMENT,
  IS_SENTRY_PROD_ENV,
  IS_SENTRY_STAGING_ENV,
} from "../sentryIntegration.constants";

const sentryBrowserInit = () => {
  if (window.Sentry === undefined) return;
  window.Sentry.init({
    dsn: SENTRY_DSN,
    environment: SENTRY_ENVIRONMENT,
    enabled: !IS_SENTRY_PROD_ENV && !IS_SENTRY_STAGING_ENV,
  });
  // The following helps ensure that `@/sentryIntegration/Sentry` provides the
  // proper value for code excuting on a browser.
  setSentryInstance(window.Sentry);
};

export default sentryBrowserInit;
